export default "__VITE_ASSET__fxrFsB43__"